import React, {Component, Fragment} from 'react';
import { connect } from 'react-redux';
import spinner from '../../../FO/resources/img/loading.gif';
import { getHallConfiguration } from "../../actions/movietheaters.actions";
import { getMovieDetails } from "../../actions/movies.actions";

import Spinner from "../spinner/spinner.component";
import HallMap from "../hallmap/hallmap.component";

import ReservationStep2 from "../modalreservation/reservationstep2.component";
import ReservationStep1 from "../modalreservation/reservationstep1.component";
import {storeSelectedHour} from '../../actions/filters.actions'
import moment from "moment";
import "moment/locale/ro";

class HallDetailsMobile extends Component {

    constructor(props) {
        super(props);
        this.state = {
            nextStep: false
        }
        this.goToNextStep = this.goToNextStep.bind(this);
    }

    componentWillUnmount(){
        document.body.classList.remove("hallDetailsMobile");
    }

    componentWillMount() {
        document.body.classList.add("hallDetailsMobile");

        const cinemaId = this.props.match.params.cinemaId;
        const hallId = this.props.match.params.hallId;
        const eventId = this.props.match.params.eventId;
        const movieId = this.props.match.params.movieId;
        const scheduleId = this.props.match.params.scheduleId;
        const userId = this.props.match.params.userId;

        let check = setInterval( () => {
            if(window.localStorage.getItem('access_token') !== null) {
                this.props.getHallConfiguration(eventId);
                clearInterval(check);
            }
        }, 500);
        //this.props.getHallConfiguration(eventId);
        this.props.getMovieDetails(movieId);
        this.props.storeSelectedHour({eventId, movieId, scheduleId, userId});
    }

    goToNextStep = (step) => {
        this.setState({
            nextStep: !this.state.nextStep
        })
    };

    getScheduleTime = () => {
        const timestamp = this.props.match.params.timestamp;
        const projectionFormat = this.props.match.params.projection;

        return {
            day: moment.unix(timestamp).locale('ro').format("dddd"),
            selectedHour: moment.unix(timestamp).locale('ro').tz('Europe/Bucharest').format("HH:mm"),
            selectedDate: moment.unix(timestamp).format("DD.MM.YYYY"),
            projectionFormat: projectionFormat
        }
    }

    render() {
        return (
            <div className="hall-details-mobile">
                {this.props.loading !== 0 ? <Spinner /> : ''}
                <div className="container">
                    { !this.state.nextStep ?
                    <Fragment>
                        <ReservationStep1/>
                        <div className="row">
                            {this.props.selectedSeats.length > 0 || this.props.selectedCouch.length > 0 ? 
                                <button className="next-step" onClick={this.goToNextStep}>Pasul următor</button> : "" }
                        </div>
                    </Fragment> : 
                    <ReservationStep2 scheduleTime={this.getScheduleTime()} goToNextStep={() => this.goToNextStep}/>
                    }
                </div>
            </div>
        );
    }
}

const mapStateToProps = state => ({
    loading: state.loading.pendingRequests,
    movie: state.movies.movieDetails,
    selectedSeats: state.movieTheaters.selectedSeats,
    selectedCouch: state.movieTheaters.selectedCouch
});
export default connect(mapStateToProps, {getHallConfiguration, getMovieDetails, storeSelectedHour})(HallDetailsMobile);





// WEBPACK FOOTER //
// ./src/SHARED/components/halldetailsmobile/halldetailsmobile.component.js